import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface CapabilityOptions {
  uuid: string;
  name: string;
}[]

export function useGetCapabilities() {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['capabilities'],
    queryFn: async (): Promise<CapabilityOptions> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/graph_bundle/functions/get_available_capabilities`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET'
        }
      );

      const data = await response.json();

      return data?.data;
    },
  });
}
